<div [matMenuTriggerFor]="popoverMenu" class="inline-block cursor-pointer">
  <ng-content></ng-content>
</div>

<mat-menu #popoverMenu="matMenu" xPosition="before">
  <ng-template matMenuContent>
    <div>
      <ng-container
        *ngComponentOutlet="contentComponent(); inputs: componentInputs"
      ></ng-container>
    </div>
  </ng-template>
</mat-menu>
